iScreenWizard.factory('WizardFeedback', function ($q, Ajax, Groepscode) {

    var data = {};

    data.store = function(feedback) {
        return $q(function (resolve, reject) {
            if (feedback.group_code && feedback.group_code.length > 0) {
                var urlFriendlyValue = encodeURIComponent(
                    feedback.group_code
                );
                Groepscode.all({titel: urlFriendlyValue}).then(function (groepscodes) {
                    if (groepscodes.length > 0) {
                        //groepscode bestaat al, gebruik deze
                        groepscode = groepscodes[0];
                        feedback.groepscode_id = groepscode.id;
                        resolve(realStore(feedback));
                    } else {
                        //create groepscode
                        Ajax.post('groepscode', {titel: feedback.group_code}).then(function (response) {
                            feedback.groepscode_id = response.data.id;
                            resolve(realStore(feedback));
                        });
                    }
                });
            } else {
                //geen groepscode ingevoerd
                resolve(realStore(feedback));
            }
        });
    };

    data.downloadReport = function(feedback, params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        params._method = 'genereer_rapport';
        params.wizardfeedbacksessie_id = feedback.id;

        return $q(function (resolve, reject) {
            Ajax.get('wizardfeedback', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    var realStore = function(feedback) {
        params = feedback;
        params._method = 'nieuwe_wizardfeedback_uitnodiging';

        return $q(function (resolve, reject) {
            Ajax.post('wizardfeedback', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});